import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Stack,
  IconButton,
  Link as MuiLink,
  Divider,
} from "@mui/material";
import { Link } from "react-router-dom";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import XIcon from '@mui/icons-material/X';
import { Homeimages, hydfooterimg } from "../../assets";
import YouTube from "@mui/icons-material/YouTube";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";


const Footer: React.FC = () => {
  return (
    <Box
      sx={{
        pt: 12,
        pb: 1,
        color: "white",
        overflow: "hidden",
        backgroundImage: `
          linear-gradient(rgba(15,99,165,0.85), rgba(15,99,165,0.88)),
          url("https://dprstorage.b-cdn.net/RW/bannerbg2.png")
        `,
        backgroundSize: "cover",
        backgroundPosition: "center 100%",
      }}
    >
      <Container maxWidth="xl" sx={{ px: { xs: 2, md: 10 } }}>
        <Grid container spacing={{ xs: 3, md: 10, lg: 6 }}>
          {/* COLUMN 1 */}
          <Grid item xs={12} md={3}>
            <img
              src={Homeimages.rwsignlogo}
              alt="Rajiv Williams signature logo"
              width={100}
              loading="lazy"
              style={{ marginBottom: 12 }}
            />

            <Box sx={{ display: "flex", alignItems: "center", gap: 0, mt: 2 }}>
              {["Clarity", "Confidence", "Conversion"].map((item, index) => (
                <React.Fragment key={item}>
                  {index !== 0 && (
                    <Typography
                      component="span"
                      sx={{
                        fontSize: 24,      // ✅ Bigger dot
                        fontWeight: 700,
                        color: "#fff",
                        mx: 1,
                      }}
                    >
                      •
                    </Typography>
                  )}

                  <Typography
                    variant="body2"
                    component="span"
                    fontSize={14}
                    fontWeight={600}
                    color="#fff"
                  >
                    {item}
                  </Typography>
                </React.Fragment>
              ))}
            </Box>

            <Stack direction="row" spacing={1} mt={3}>
              <IconButton
                component="a"
                href="https://www.facebook.com/williamsrajiv"
                target="_blank"
                sx={{
                  background: "rgba(255,255,255,0.15)",
                  color: "white",
                  "&:hover": { background: "white", color: "#0f63a5" },
                }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                component="a"
                href="https://x.com/RajivCWilliams?t=2UnilCIJUvX9kQG1dAaXaw&s=09"
                target="_blank"
                sx={{
                  background: "rgba(255,255,255,0.15)",
                  color: "white",
                  "&:hover": { background: "white", color: "#0f63a5" },
                }}
              >
                <XIcon />
              </IconButton>

              <IconButton
                component="a"
                href="https://www.instagram.com/williams_rajiv/"
                target="_blank"
                sx={{
                  background: "rgba(255,255,255,0.15)",
                  color: "white",
                  "&:hover": { background: "white", color: "#0f63a5" },
                }}
              >
                <InstagramIcon />
              </IconButton>

              <IconButton
                component="a"
                href="https://www.linkedin.com/in/rajivwilliams/"
                target="_blank"
                sx={{
                  background: "rgba(255,255,255,0.15)",
                  color: "white",
                  "&:hover": { background: "white", color: "#0f63a5" },
                }}
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                component="a"
                href="https://www.youtube.com/@rajiv-williams"
                target="_blank"
                sx={{
                  background: "rgba(255,255,255,0.15)",
                  color: "white",
                  "&:hover": { background: "white", color: "#0f63a5" },
                }}
              >
                <YouTube />
              </IconButton>
            </Stack>
          </Grid>

          {/* COLUMN 2 */}
          {/* COLUMN 2 */}
          <Grid item xs={12} md={3}
            sx={{
              pr: { xs: "auto", md: 4, lg: "auto" },
              textAlign: { xs: "start", md: "start" },
            }}
          >
            <Typography variant="h6" fontWeight={700} mb={2}
              sx={{
                color: "white",
                textAlign: { xs: "start", md: "start" },
                fontSize: { xs: 20, md: 20 }

              }}
            >
              Quick Links
            </Typography>

            <Stack spacing={2}>
              {[
                { label: "About Us", path: "/about-us" },
                { label: "Coaching", path: "/services/luxury-sales-coach" },
                { label: " Consulting", path: "/services/luxury-sales-consulting" },
                { label: " realty", path: "/services/realty" },
               
              ].map((item, index) => (
                <Stack
                  key={index}
                  direction="row"
                  alignItems="center"
                  spacing={1}
                  textAlign="start"
                >
                  <ArrowRightAltIcon sx={{ fontSize: 18, color: "#ffffffcc" }} />

                  <MuiLink
                    component={Link}
                    to={item.path}
                    underline="none"
                    sx={{
                      color: "white",
                      fontSize: { xs: 18, md: 18 },
                      transition: "0.3s",
                      "&:hover": {
                        color: "#000",
                        transform: "translateX(4px)",
                      },
                    }}
                  >
                    {item.label}
                  </MuiLink>
                </Stack>
              ))}
            </Stack>
          </Grid>


          {/* COLUMN 3 */}
          {/* COLUMN 3 */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" fontWeight={700} mb={2}
              sx={{
                color: "white",
                textAlign: { xs: "start", md: "start" },
                fontSize: { xs: 20, md: 20 }
              }}
            >
              Resources
            </Typography>

            <Stack spacing={2}>
              {[
                { label: "FAQ", path: "/faqs" },
                 { label: "Blogs", path: "/blogs" },
                // { label: "Free Webinars", path: "/" },
              ].map((item, index) => (
                <Stack
                  key={index}
                  direction="row"
                  alignItems="center"
                  spacing={1}
                >
                  <ArrowRightAltIcon sx={{ fontSize: 18, color: "#ffffffcc" }} />

                  <MuiLink
                    component={Link}
                    to={item.path}
                    underline="none"
                    sx={{
                      color: "white",
                      fontSize: 18,
                      transition: "0.3s",
                      "&:hover": {
                        color: "#000",
                        transform: "translateX(4px)",
                      },
                    }}
                  >
                    {item.label}
                  </MuiLink>
                </Stack>
              ))}
            </Stack>
          </Grid>


          {/* COLUMN 4 */}
          {/* COLUMN 4 */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              fontWeight={700}
              mb={2}
              sx={{
                color: "white",
                textAlign: { xs: "start", md: "start" },
                fontSize: { xs: 20, md: 20 }

              }}
            >
              Contact
            </Typography>

            <Stack
              spacing={2}
              alignItems={{ xs: "start", md: "flex-start" }}
            >
              {/* Phone */}
              <Stack
                direction="row"
                spacing={1.5}
                alignItems="center"
                sx={{
                  transition: "0.3s",
                  "&:hover": { transform: "translateX(4px)" },
                }}
              >
                <PhoneIcon sx={{ fontSize: 18 }} />

                <MuiLink
                  href="tel:+919549546568"
                  underline="none"
                  sx={{
                    color: "white",
                    fontSize: 18,
                    transition: "0.3s",
                    "&:hover": { color: "#000" },
                  }}
                >
                  +91 95495 46568
                </MuiLink>
              </Stack>

              {/* Email */}
              <Stack
                direction="row"
                spacing={1.5}
                alignItems="center"
                sx={{
                  transition: "0.3s",
                  "&:hover": { transform: "translateX(4px)" },
                }}
              >
                <EmailIcon sx={{ fontSize: 18 }} />

                <MuiLink
                  href="mailto:connect@rajivwilliams.com"
                  underline="none"
                  sx={{
                    color: "white",
                    fontSize: 18,
                    transition: "0.3s",
                    "&:hover": { color: "#000" },
                  }}
                >
                  connect@rajivwilliams.com
                </MuiLink>
              </Stack>

              {/* Address (NEW) */}
              <Stack
                direction="row"
                spacing={1.5}
                alignItems="flex-start"
                sx={{
                  transition: "0.3s",
                  "&:hover": { transform: "translateX(4px)" },
                }}
              >
                <PhoneIcon sx={{ fontSize: 18 }} />

                <MuiLink

                  underline="none"   // ✅ Removes underline
                  sx={{
                    color: "white",
                    fontSize: 18,
                    lineHeight: 1.6,
                    // maxWidth: 220,
                    // fontWeight: 800,
                    textAlign:'start',
                    "&:hover": {
                      textDecoration: "none",  // Extra safety
                    },
                  }}
                >
                  Hyderabad, Telangana, India
                </MuiLink>
              </Stack>
            </Stack>
          </Grid>

        </Grid>

        <Divider sx={{ borderColor: "rgba(255,255,255,0.3)", my: 6 }} />

        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body2"
            sx={{
              fontWeight: 700,
              color: "white",
            }}
          >
            © 2026 All Rights Reserved
          </Typography>

          <Stack direction="row" spacing={1}>

            <MuiLink component={Link} to="/privacy-policy" underline="none" color="white">
              <Typography variant="body2"
                sx={{
                  fontWeight: 700,
                  color: "white",
                }}
              >
                Privacy Policy /
              </Typography>

            </MuiLink>

            <MuiLink component={Link} to="/terms-and-conditions" underline="none" color="white">
              <Typography variant="body2"
                sx={{
                  fontWeight: 700,
                  color: "white",
                }}
              >
                Terms of Service
              </Typography>

            </MuiLink>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
